import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { LoggedOutLayout } from 'containers';

var SignedContractInternalPayment = /*#__PURE__*/function (_Component) {
  _inherits(SignedContractInternalPayment, _Component);

  var _super = _createSuper(SignedContractInternalPayment);

  function SignedContractInternalPayment() {
    _classCallCheck(this, SignedContractInternalPayment);

    return _super.apply(this, arguments);
  }

  _createClass(SignedContractInternalPayment, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Agreement Signed"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement(Paper, {
        zDepth: 1,
        style: {
          margin: 48,
          maxWidth: 500,
          padding: 32,
          paddingTop: 12
        }
      }, /*#__PURE__*/React.createElement("h1", {
        style: {
          textAlign: 'center',
          fontSize: '36px'
        }
      }, "Welcome to Likeable Local!"), /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-checkmark-outline",
        style: {
          color: 'green',
          fontSize: 95
        }
      })), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '17px',
          textAlign: 'center',
          lineHeight: '24px'
        }
      }, "Your sales representative will now walk you through the final steps of setting up your account."), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '17px',
          textAlign: 'center',
          lineHeight: '24px'
        }
      }, "You may close this window now."))));
    }
  }]);

  return SignedContractInternalPayment;
}(Component);

export { SignedContractInternalPayment as default };